import { IAvatarAssetImage } from './IAvatarAssetImage';

export interface IAvatarAssetFaceEmotion {
    id: string;
    categoryId: string; // IAssetFaceEmotionCategory->id
    image: IAvatarAssetImage;
}
